// extracted by mini-css-extract-plugin
export var externalLink = "_9m-0";
export var internalLinkLabel = "_9m-1";